module.exports = __webpack_public_path__ + "img/materiales_en_saco_y_en_silo.2473c097.png";